export default class Turnstile {
	public constructor(form: HTMLFormElement, siteKey: string) {
		const id: string = `turnstile_${crypto.randomUUID()}`;
		const turnstileWrapper: HTMLDivElement = document.createElement('div');
		turnstileWrapper.id = id;
		turnstileWrapper.dataset.action = 'wp_register';
		form.appendChild(turnstileWrapper);

		const renderTurnstile = () => turnstile.render(`#${id}`, { sitekey: siteKey });

		if (typeof turnstile === 'undefined') {
			const script: HTMLScriptElement = document.createElement('script');
			script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
			script.defer = true;
			script.onload = renderTurnstile;
			document.body.appendChild(script);
		} else {
			renderTurnstile();
		}
	}
}
